import React from 'react';
import { formatDuration } from '../../helpers/boh_spotlights';
const Row = ({
  store,
  isOwn,
  accent_color
}) => {
  const {
    location,
    value,
    ranking
  } = store;
  const style = {
    '--accent-color': accent_color
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${isOwn && 'list-item-own'}`,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "store-column"
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, ranking, "."), " ", location)), /*#__PURE__*/React.createElement("div", {
    className: "sos-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("b", null, formatDuration(value)))));
};
export default Row;